module.exports = __webpack_public_path__ + "static/21-slideshow-9c969881ed9fff580848bd3e097e8327.jpg";